import wordCount from 'words-count';
export var WORD_COUNT_FEATURE = 'WORD_COUNT_FEATURE';
export var wordCountFeature = function (editorState) {
    var plain = editorState.getCurrentContent().getPlainText();
    var words = parseInt(wordCount(plain)) || 0;
    return {
        type: WORD_COUNT_FEATURE,
        data: {
            words: words,
            chars: plain.length,
        },
    };
};
//# sourceMappingURL=wordCount.js.map